import styled from "styled-components";
import Toast from "./mocks/toast/Toast";
import OrderStatusLabel from "./mocks/orderStatus/OrderStatusLabel";
import { OrderStatus } from "@ancon/wildcat-types";
import CheckoutOutOfStockBanner from "./mocks/warnings/CheckoutOutOfStockBanner";
import CheckoutOutOfStockFormItem from "./mocks/warnings/CheckoutOutOfStockFormItem";
import OrderDetailsDrawer from "./mocks/orderSummary/OrderDetailsDrawer";
import Card from "./mocks/card/Card";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  margin-left: 10px;

  > h3 {
    margin-top: 10px;
    margin-bottom: 10px;
    color: black;
  }
`;

const OrderStatusContainer = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  background: var(--colors-surfaces-primary-0);
  padding: 5px 10px;
`;

const CardContainer = styled(Card)``;

export default function WebTagPreviews({ className }: { className?: string }) {
  return (
    <Container className={className}>
      <Toast variant="info" title="Info Toast" />
      <Toast variant="success" title="Success Toast" />
      <Toast variant="error" title="Error Toast" />

      <h3>Order Status Tags</h3>
      <OrderStatusContainer>
        <OrderStatusLabel status={OrderStatus.Refunded} />
      </OrderStatusContainer>
      <OrderStatusContainer>
        <OrderStatusLabel status={OrderStatus.PartlyRefunded} />
      </OrderStatusContainer>
      <OrderStatusContainer>
        <OrderStatusLabel status={OrderStatus.NotRefunded} />
      </OrderStatusContainer>

      <h3>Warning Status Tags</h3>
      <OrderStatusContainer>
        <CheckoutOutOfStockBanner />
      </OrderStatusContainer>
      <OrderStatusContainer>
        <CheckoutOutOfStockFormItem />
      </OrderStatusContainer>

      <h3>Order Summary</h3>
      <CardContainer>
        <OrderDetailsDrawer />
      </CardContainer>
    </Container>
  );
}
